import {get, put} from './http';

export type P0EscalationConfig = {
  enabled: boolean;
  threshold_minutes: number;
  status_check_interval_minutes: number;
  modified_by: string | null;
  modified_at: string | null;
};

export type UpdateP0EscalationConfigPayload = {
  enabled: boolean;
  threshold_minutes: number;
  status_check_interval_minutes: number;
};

export const p0EscalationConfigApi = {
  get: async () => get<P0EscalationConfig>('/p0-escalation-config'),
  update: async (payload: UpdateP0EscalationConfigPayload) =>
    put<UpdateP0EscalationConfigPayload, P0EscalationConfig>('/p0-escalation-config', payload)
};
